// extracted by mini-css-extract-plugin
export default {"tabIcon":"persistent-cache-task_tabIcon__yLVz8"};